<template>
    <div class="row">

        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">{{ tableTitle }}</h3>
            </div>
            <table class="table table-bordered table-striped">
                <thead>
                <tr>
                    <th>Session Date</th>
                    <th v-show="useSessionNames == true">Session</th>
                    <th>Location</th>
                    <th class="text-center">Session Time</th>
                    <th class="text-center">Charge</th>
					<th class="text-center">Spaces</th>
                    <th>Member</th>
                    <th class="text-center">Signed Up</th>
                    <th class="row-actions">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(trainingSession,index) in trainingSessions" v-if="trainingSessions.length > 0">
                    <td>
                        {{ formatDate(trainingSession.date_time) }}
                    </td>
                    <td v-show="useSessionNames == true">
                        {{ trainingSession.training_session.training_session_name }}
                    </td>
                    <td>
                        {{ trainingSession.training_location.name}}
                    </td>
                    <td class="text-center">
                        {{ formatTime(trainingSession.date_time) }}
                    </td>
                    <td class="text-center">
                        {{ formatPayPerSwimRate(trainingSession.training_session.pay_per_swim_rate) }}
                    </td>
					<td class="text-center">
						{{ trainingSession.number_of_spaces }}
					</td>
                    <td>
                        {{ trainingSession.member.name }}
                    </td>
                    <td class="text-center">
                        <span v-if="trainingSession.signed_up" class="glyphicon glyphicon-ok text-success" aria-hidden="true"></span>
                        <span v-if=" ! trainingSession.signed_up " class="glyphicon glyphicon-remove text-danger" aria-hidden="true"></span>
                    </td>
                    <td class="row-actions">
                        <button v-if="trainingSession.available_for_signup" class="btn btn-success btn-sm" @click="handleSignup(index, trainingSession)">Sign Up</button>
                        <!-- <button class="btn btn-primary btn-sm" @click="handleEdit(index, group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> -->
                        <button v-if="trainingSession.can_cancel_signup" class="btn btn-danger btn-sm" @click="handleCancel(index, trainingSession)">Cancel</button>
                    </td>
                </tr>
                <tr v-if="trainingSessions.length == 0">
                    <td colspan="6" align="center">
                        <strong>There are no available sessions for sign up</strong>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>


    </div>


</template>



<script>

    import { Loading } from 'element-ui';
    import lang from 'element-ui/lib/locale/lang/en';
    import locale from 'element-ui/lib/locale';
    locale.use(lang);

    export default {
        props: {
            title: {
                type: String,
                default: "Training Sessions"
            },
            can_manage: {
                type: Boolean,
                default: false
            },
            useSessionNames: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                trainingSessions: [],
                tableTitle: this.title,
            }
        },
        computed: {
        },
        mounted() {
            this.debug('Training Session Signup component mounted.');
            this.loadTrainingSessions();
        },
        methods: {
            formatDate(date) {
                return moment(date).tz('UTC').format('dddd Do MMMM YYYY');
            },
            formatTime(date) {
                return moment(date).tz('UTC').format('h:mma');
            },

            formatPayPerSwimRate(rate) {
                let formatter = new Intl.NumberFormat('en-GB', {
                    style: 'currency',
                    currency: 'GBP',
                    minimumFractionDigits: 2
                })
                if (rate && (rate != 0)) {
                    return formatter.format(rate);
                }
                return '-';
            },


            handleSignup(index, record) {
                this.debug('Signing up record: ' + record.id);
                axios.patch(`/account/api/member_training_session/${record.id}`, { signed_up: true}).then((response) => {
                    // this.loadingInstance.close();
                    this.debug(response.data);
                    // this.trainingSessions[index] = response.data; // Won't work because Vue won't detect the change
                    Vue.set(this.trainingSessions, index, response.data);
                    //this.loadTrainingSessions();
                    this.$message({message: 'The training set has been signed up for.', type: 'success'});
                }).catch((error) => {
                    // this.loadingInstance.close();
                    console.log(error);
                    this.$message({message: 'There was a problem updating the training set.', type: 'error'});
                });
            },
            handleCancel(index, record) {
                this.debug('Cancelling record: ' + record.id);
                axios.patch(`/account/api/member_training_session/${record.id}`, { signed_up: false}).then((response) => {
                    // this.loadingInstance.close();
                    this.debug(response.data);
                    // this.trainingSessions[index] = response.data; // Won't work because Vue won't detect the change
                    Vue.set(this.trainingSessions, index, response.data);
                    // this.loadTrainingSessions();
                    this.$message({message: 'The training set has been signed up for.', type: 'success'});
                }).catch((error) => {
                    console.log(error);
                    // this.loadingInstance.close();
                    this.$message({message: 'There was a problem updating the training set.', type: 'error'});
                });
            },
            loadTrainingSessions() {
                this.debug('loadSessions()');
                axios.get(`/account/api/member_training_sessions/signup`)
                    .then(response => {
                        this.trainingSessions = response.data;
                        console.log(this.trainingSessions);
                        console.log(this.trainingSessions.length);
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching training sessions.', type: 'error'});
                        console.log(error);
                    });
            },
            debug(message) {
                console.log('TrainingSetList: ' + message);
            }
        }
    }
</script>
